
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 44 44"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"fill":"#FFF","cx":"22","cy":"22","r":"18.5"}}),_c('path',{staticClass:"st2",attrs:{"fill":"#1DA1F2","d":"M22 0C9.9 0 0 9.9 0 22s9.9 22 22 22 22-9.9 22-22S34.1 0 22 0zm11 17.9v.7c0 7-5.4 15-15 15-2.9 0-5.7-.9-8.1-2.4.4 0 .9.1 1.2.1 2.4 0 4.8-.7 6.6-2.3-2.3 0-4.3-1.5-4.9-3.7.4.1.6.1 1 .1.5 0 1-.1 1.3-.2-2.4-.5-4.3-2.7-4.3-5.3v-.1c.7.4 1.6.6 2.4.6-2.3-1.3-3.1-4.4-1.7-6.8 2.7 3.3 6.7 5.4 10.9 5.5-.1-.4-.1-.9-.1-1.2 0-1.5.6-2.8 1.7-3.9 2.1-2 5.5-2 7.5.2 1.2-.2 2.3-.6 3.4-1.3-.4 1.2-1.2 2.3-2.3 2.9 1.1-.1 2.1-.4 3.1-.9-.7 1.3-1.6 2.2-2.7 3z"}})])
          )
        }
      }
    